import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { RIEInput } from 'riek'

import EventSharingForm from './event-sharing/sharing-form'

class EventBreadcrumbs extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      showSharingDropdown: false
    }

    this.title = React.createRef()
  }

  componentWillMount() {
    const { event } = this.props

    if (event.title) this.setState({title: event.title})
  }

  renderDropdown() {
    const { event } = this.props
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--main': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})}>
          <div className="ui-dropdown-handle-ball" />
          <div className="ui-dropdown-handle-ball" />
          <div className="ui-dropdown-handle-ball" />
        </div>

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showDropdown: false}, () => this.title.current.startEditing())}>Rename event</li>
              <li onClick={() => this.setState({showDropdown: false, showSharingDropdown: true})}>Share rider</li>
              <li onClick={() => this.props.deleteEvent()}>Delete event</li>
              {
                event.stages.map((stage, index) => <li key={index} onClick={() => this.props.deleteEventStage(stage.id)}>{`Delete stage "${stage.title}"`}</li>)
              }
            </ul>
          : null
        }
      </div>
    )
  }

  renderSharingDropdown() {
    const { view, event } = this.props
    const { users } = event
    const { showSharingDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--sharing': true,
      'ui-dropdown--active': showSharingDropdown
    })

    return (
      <div className={className}>
        {showSharingDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showSharingDropdown: !showSharingDropdown})} /> : null}

        <div className="ui-dropdown-value" onClick={() => this.setState({showSharingDropdown: !showSharingDropdown})}>Share</div>

        {
          showSharingDropdown === true
          ? <ul className="ui-dropdown-content">
              <li>
                <small>Invite event organizer with write permission:</small>
              </li>
              <li>
                <EventSharingForm
                  removeFocus={() => this.setState({showSharingDropdown: false})}
                  createEventUser={this.props.createEventUser} />
              </li>
              {
                users.length > 0
                ? <li>
                    <small>Current collaborators:</small>
                    <ol>
                      {
                        users.map((user, index) => {
                          if (user.id !== (view.user && view.user.id)) return <li key={index} onClick={() => this.props.deleteEventUser(user.id)}>— {user.email}</li>
                          return null
                        })
                      }
                    </ol>
                  </li>
                : null
              }
            </ul>
          : null
        }
      </div>
    )
  }

  render() {
    const { view, event, stage } = this.props
    const { title } = this.state

    const titleClassName = classnames({
      'riek': true,
      'riek--focusable': view.editable,
      'title': true,
      'h1': true,
      'placeholder': !title
    })

    return (
      <div className="event-breadcrumbs">
        {
          view.editable
          ? <RIEInput ref={this.title}
              value={title || 'Title - click to add'}
              propName="title"
              className={titleClassName}
              classEditing="riek-editing"
              change={({title}) => this.setState({title}, () => this.props.editEvent({title}))} />
          : <div className={titleClassName}>{event.title}</div>
        }

        {/*
          stage.title
          ? <h4>{stage.title}</h4>
          : null
        */}

        {
          view.editable
          ? this.renderSharingDropdown()
          : null
        }

        {/*
          <ul>
            {
              event.users.map((user, index) => <li key={index}>{user.email}</li>)
            }
          </ul>
        */}

        {
          view.editable
          ? this.renderDropdown()
          : null
        }
      </div>
    )
  }
}

EventBreadcrumbs.propTypes = {
  view: PropTypes.object,
  event: PropTypes.object,
  stage: PropTypes.object,
  editEvent: PropTypes.func,
  deleteEvent: PropTypes.func,
  deleteEventStage: PropTypes.func,
  createEventUser: PropTypes.func,
  deleteEventUser: PropTypes.func
}

EventBreadcrumbs.defaultProps = {
  view: {},
  event: {},
  stage: {},
  editEvent: function() {},
  deleteEvent: function() {},
  deleteEventStage: function() {},
  createEventUser: function() {},
  deleteEventUser: function() {}
}

export default EventBreadcrumbs



// WEBPACK FOOTER //
// ./src/components/event/event-breadcrumbs.js